// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import datatable from '../datatable'
import userOperations$ from '../selectors/operations'
import { authenticatedUser$ } from 'fc-authenticated-user'
import billingInfoOps$ from '../selectors/billingInfoOperation'
import { users$ } from 'fc-users'

// Operator
import usersOperator from 'fc-operator-user'
import billingInfoOperator from 'hfty-operator-billing-info'

// Action Creator
import { addUser, editUsers, deleteUser, editBillingInfo } from '../actions'

// State -> Props
type Props = {
  selectedIds: Array<number>,
  userId: number,
}

function mapStateToProps (state: Object): Props {
  return {
    selectedIds: datatable.selectors.selectedRecordIds$(state),
    operation: userOperations$(state),
    authenticatedUser: authenticatedUser$(state),
    billingOperation: billingInfoOps$(state),
    users: users$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onEdit: Function,
    onDelete: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onAdd: addUser,
      onEdit: editUsers,
      onDelete: deleteUser,
      onEditBilling: editBillingInfo,
      onChangeOperation: usersOperator.actionCreators.updateOperation,
      onCancelOperations: usersOperator.actionCreators.cancelOperations,
      onSubmitOperations: usersOperator.actionCreators.submitOperations,
      onChangeBillingOperation: billingInfoOperator.actionCreators.updateOperation,
      onCancelBillingOperation: billingInfoOperator.actionCreators.cancelOperation,
      onSubmitBillingOperations: billingInfoOperator.actionCreators.submitOperations,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
